import React from "react";

/**
 * StarField — shared deep-space CSS starfield used across all dark sections of
 * the About page to create ONE continuous space background (hero → capabilities
 * → how-it-works → final CTA). Replaces the previous per-section gradient bg
 * which caused a visible cut-off between sections.
 *
 *  - 28 randomly distributed stars at varying brightness levels
 *  - 6 "highlight" larger stars for visual rhythm
 *  - Pointer-events disabled so it never blocks interactions
 *  - Designed to layer over a #0F172A bg
 */
export default function StarField({ className = "", opacity = 0.55 }) {
  return (
    <div
      className={`absolute inset-0 pointer-events-none ${className}`}
      aria-hidden
      style={{
        opacity,
        backgroundImage: `
          radial-gradient(2px 2px at 8%  6%,  rgba(255,255,255,0.95), transparent 60%),
          radial-gradient(1px 1px at 14% 18%, rgba(255,255,255,0.75), transparent 45%),
          radial-gradient(1px 1px at 22% 28%, rgba(255,255,255,0.7),  transparent 45%),
          radial-gradient(2px 2px at 31% 11%, rgba(255,255,255,0.9),  transparent 55%),
          radial-gradient(1px 1px at 37% 35%, rgba(255,255,255,0.65), transparent 45%),
          radial-gradient(1px 1px at 44% 8%,  rgba(255,255,255,0.7),  transparent 45%),
          radial-gradient(1px 1px at 49% 22%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(2px 2px at 56% 42%, rgba(255,255,255,0.85), transparent 55%),
          radial-gradient(1px 1px at 62% 14%, rgba(255,255,255,0.7),  transparent 45%),
          radial-gradient(1px 1px at 67% 31%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(1px 1px at 73% 9%,  rgba(255,255,255,0.7),  transparent 45%),
          radial-gradient(2px 2px at 79% 24%, rgba(255,255,255,0.9),  transparent 55%),
          radial-gradient(1px 1px at 85% 38%, rgba(255,255,255,0.65), transparent 45%),
          radial-gradient(1px 1px at 92% 16%, rgba(255,255,255,0.75), transparent 45%),
          radial-gradient(1px 1px at 5%  47%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(1px 1px at 11% 58%, rgba(255,255,255,0.55), transparent 45%),
          radial-gradient(2px 2px at 19% 71%, rgba(255,255,255,0.8),  transparent 55%),
          radial-gradient(1px 1px at 27% 82%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(1px 1px at 33% 64%, rgba(255,255,255,0.5),  transparent 45%),
          radial-gradient(1px 1px at 41% 89%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(2px 2px at 48% 76%, rgba(255,255,255,0.85), transparent 55%),
          radial-gradient(1px 1px at 55% 92%, rgba(255,255,255,0.55), transparent 45%),
          radial-gradient(1px 1px at 63% 68%, rgba(255,255,255,0.65), transparent 45%),
          radial-gradient(1px 1px at 71% 87%, rgba(255,255,255,0.5),  transparent 45%),
          radial-gradient(2px 2px at 78% 53%, rgba(255,255,255,0.9),  transparent 55%),
          radial-gradient(1px 1px at 84% 78%, rgba(255,255,255,0.6),  transparent 45%),
          radial-gradient(1px 1px at 90% 62%, rgba(255,255,255,0.7),  transparent 45%),
          radial-gradient(1px 1px at 96% 88%, rgba(255,255,255,0.55), transparent 45%)
        `,
      }}
    />
  );
}
